import React, { useEffect, useState } from 'react';
import { IModalWindow, ModalWindow } from '../../components/modal/ModalWindow';
import { useMerchants } from '../../store/merchnts/merchants-context';
import './Logs.scss';
import { fetchWebhookLogs, resendWebhook, setWebhookLogsPagination } from '../../store/merchnts/actions/webhooks';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../../components/table/Table';
import { useTranslation } from 'react-i18next';
import { BUTTON_TYPE, ButtonComponent } from '../../components/ButtonComponent';

export interface IWebhookLogParams {
	pageSize: number,
	pageNumber: number,
}
export const Logs = (): JSX.Element => {
	const { t } = useTranslation();
	const [loading, setLoading] = useState({
		isLoading: false,
		id: ''
	});
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});
	const {
		merchantState: {
			webhooksLogData,
			isWebhooksLogDataLoading,
			webhooksLogTablePageNumber,
			webhooksLogTablePageSize,
			webhooksLogTotalItemCount,
		},
		dispatch
	} = useMerchants();

	const refetchLogs = async (): Promise<void> => {
		const params: IWebhookLogParams = {
			pageSize: webhooksLogTablePageSize,
			pageNumber: webhooksLogTablePageNumber + 1
		};
		await fetchWebhookLogs(dispatch, params);
	};

	useEffect(() => {
		void refetchLogs();
	},[webhooksLogTablePageSize, webhooksLogTablePageNumber]);


	const onCloseModal = (): void => setModalState(prevState => ({ ...prevState, isOpen: false }));

	const handleModalOpen = (payload): void => {
		setModalState({
			isOpen: true,
			modalTitle: 'Log information',
			contentClassName: 'd-block pb-1',
			content: (
				<div className="sense-script m-6">
					<pre className="code-area p-5">
						{payload}
					</pre>
				</div>
			)
		});
	};

	const handleResendWebhook = async (eventInvocationId: string): Promise<void> => {
		setLoading({
			isLoading: true,
			id: eventInvocationId
		});
		await resendWebhook(eventInvocationId);
		setLoading({
			isLoading: true,
			id: ''
		});
		await refetchLogs();
	};

	const openResendModal = (eventInvocationId: string): void => {
		setModalState({
			isOpen: true,
			modalTitle: 'Resend webhook',
			confirmButtonText: 'Resend',
			modalText: 'Are you sure you want to resend this webhook?',
			onConfirm: async (): Promise<void> => {
				await handleResendWebhook(eventInvocationId);
				onCloseModal();
			},
			onCancel: onCloseModal,
		});
	};

	const rowActions = (rowData): JSX.Element => {
		let json = '';
		if (rowData?.original?.payload) {
			const parsedJSON = JSON.parse(rowData?.original?.payload);
			json = JSON.stringify(parsedJSON, null, 4);
		}
		return (
			<div className="d-flex align-items-center justify-content-center">
				<div onClick={(): void => handleModalOpen(json)} className="cursor-pointer text-center text-muted fw-bolder fs-7">
					More info
				</div>
				<ButtonComponent
					buttonType={BUTTON_TYPE.WHITE}
					buttonName={t('WEBHOOKS.RESEND')}
					// onButtonClick={async (): Promise<void> => handleResendWebhook(rowData?.original?.eventInvocationId)}
					onButtonClick={(): void => openResendModal(rowData?.original?.eventInvocationId)}
					isDisabled={loading.isLoading && loading.id === rowData?.original?.eventInvocationId}
					// loading={loading.isLoading && loading.id === rowData?.original?.eventInvocationId}
					additionalClass="no-letter-spacing fs-7 py-1 ps-2 pe-3 w-60px d-block ms-5 "
				/>
			</div>
		);
	};

	return(
		<>
			<Table
				name={TablesNames.webhookActivityTableData}
				data={webhooksLogData ?? []}
				// pageNumber={webhooksLogTablePageNumber}
				// pageSize={webhooksLogTablePageSize}
				isLoading={isWebhooksLogDataLoading}
				totalItemCount={webhooksLogTotalItemCount}
				setPagination={(value): void => setWebhookLogsPagination(dispatch, value)}
				enableRowActions={true}
				rowActions={rowActions}
				actionColumnsSize={100}
			/>
			<ModalWindow
				{...modalState}
				onClose={onCloseModal}
			/>
		</>
	);
};
